<div class="relative flex flex-col items-center justify-center w-full h-full">
  @if (isLoading) {
    <div class="absolute top-0 left-0 z-50 w-full h-full bg-white/10">
      <nrc-loading />
    </div>
  }

  <!-- Container for an item list -->
  @if ((!isLoading && ((items() | isNonEmptyArray)) || !emptyListConfig)) {
    @switch (layout) {
      @case ('grid') {
        <nrc-grid-list
          class="flex flex-col w-full overflow-x-auto grow"
          [items]="items"
          [config]="config"
          [pageSize]="pageSize"
          (itemActionButtonEvent)="itemActionButtonEvent.emit($event)"
          (itemSelectionToggleEvent)="itemSelectionToggleEvent.emit($event)"
          (gridItemClickedEvent)="listItemClickedEvent.emit($event)"
          (configButtonClickEvent)="configButtonClickEvent.emit($event)"
        />
      }
      @case ('rows') {
        <nrc-row-list
          class="flex flex-col w-full overflow-x-auto grow shrink-1"
          [items]="items"
          [config]="config"
          [pageSize]="pageSize"
          (sortEvent)="lastSortEvent = $event; emitListOptionsEvent();"
          (rowClickedEvent)="listItemClickedEvent.emit($event)"
          (itemActionButtonEvent)="itemActionButtonEvent.emit($event)"
          (configButtonClickEvent)="configButtonClickEvent.emit($event)"
          (rowCollapsedEvent)="rowCollapsedEvent.emit($event)"
        />
      }
      @case ('row-cards') {
        <nrc-row-card-list
          class="flex flex-col w-full overflow-x-auto grow shrink-1 min-h-0"
          [items]="items"
          [config]="config"
          [infiniteScrollConfig]="infiniteScrollConfig || { enabled: false }"
          [hasMoreData]="hasMoreData"
          [isLoadingMore]="isLoadingMore"
          (loadMoreEvent)="loadMoreEvent.emit()"
          (rowCardItemClickedEvent)="listItemClickedEvent.emit($event)"
          (itemActionButtonEvent)="itemActionButtonEvent.emit($event)"
          (configButtonClickEvent)="configButtonClickEvent.emit($event)"
        />
      }
      @default {
        <div>Unable to display list</div>
      }
    }

    <!-- Infinite Scroll Loading Indicators -->
    @if (paginationType === 'infinite-scroll') {
      <!-- Loading More Indicator -->
      @if (isLoadingMore) {
        <div class="flex justify-center items-center py-4">
          <nrc-loading-spinner />
          <span class="ml-2 text-sm text-gray-400">Loading more items...</span>
        </div>
      }
    }

    <!--- Footer -->
    <div class="bottom-0 inline-flex flex-wrap items-center justify-between w-full gap-3 p-4 my-2 border-solid border-white/10 border-t-1">
      <div class="flex items-center space-x-4">
        @for (actionButton of config.actionButtons; track actionButton.id) {
          <nrc-button
            class="relative w-10 h-10"
            [icon]="actionButton?.icon"
            [label]="actionButton?.label"
            [buttonType]="actionButton?.buttonType"
            [role]="actionButton?.role"
            [tooltipText]="actionButton?.tooltipText"
            (clickEvent)="actionButtonEvent.emit({ value: items(), actionButton })"
          />
        }

        @if (config.selectMultiple) {
          <span class="text-xs text-[#898989]">
            {{ itemsSelectedText() }}
          </span>
        }
      </div>

      @if (showPaginator()) {
        <nrc-list-paginator
          [items]="items"
          [meta]="meta"
          [overflowParentElement]="listPaginatorOverflowParentElement"
          (paginationEvent)="lastPaginationEvent = $event; emitListOptionsEvent();"
        />
      }
    </div>
  }

  @if (!isLoading && emptyListConfig && (items() | isEmptyArray)) {
    <nrc-empty-list
      [headline]="emptyListConfig.headline"
      [content]="emptyListConfig.content"
      [buttonLabel]="emptyListConfig.actionLabel"
      (buttonClickEvent)="emptyListActionEvent.emit()"
    />
  }
</div>
